import Layout from '../components/layout/index.vue';
const meta = { requiresAuth:true, inmenu: true};
const menumeta = { inframe:true};
export default [
	{
		path: '/home',
		name: 'home',
		meta: { ...menumeta, name: '主页', iconClass:'icon-zhuye' },
		component: Layout,
		redirect: { path: '/home/dashboard' },
		children: (pre => [{
				meta: {...meta, name:'经营概况' },
				path: '/home/dashboard',
				name: `${pre}-dashboard`,
				component: () => import('../views/home/dashboard.vue') 
			},
			{
				meta: {...meta, name: '数据监控' },
				path: 'monitoring',
				name: `${pre}-monitoring`,
				component: () => import('../views/home/monitoring.vue')
			},
			{
				meta: {...meta, name: '工作台' },
				path: 'workbench',
				name: `${pre}-workbench`,
				component: () => import('../views/home/monitoring.vue')
			}
		])('home')
	},
	{
		path: '/financial',
		name: 'financial',
		meta: { ...menumeta, name: '财务管理', iconClass:'icon-caiwuguanli' },
		component: Layout,
		redirect: { path: '/financial/cashWater' },
		children: (pre => [{
				meta: {...meta, name:'门店流水' },
				path: '/financial/cashWater',
				name: `${pre}-cashWater`,
				component: () => import('../views/financial/cashWater.vue') 
			},{
				meta: {...meta, name:'快递员充值' },
				path: '/financial/partnerRecharge',
				name: `${pre}-partnerRecharge`,
				component: () => import('../views/financial/partnerRecharge.vue') 
			},{
				meta: {...meta, name:'短信充值' },
				path: '/financial/smsRecharge',
				name: `${pre}-smsRecharge`,
				component: () => import('../views/financial/smsRecharge.vue') 
			},
			{
				meta: {...meta, name:'财务月报' },
				path: '/financial/analyze',
				name: `${pre}-analyze`,
				component: () => import('../views/financial/analyze.vue') 
			},
			{
				meta: {...meta, name:'财务日报' },
				path: '/financial/analyzeDay',
				name: `${pre}-analyzeDay`,
				component: () => import('../views/financial/analyzeDay.vue') 
			}
		])('financial')
	},
	{
		path: '/basis',
		name: 'basis',
		meta: { ...menumeta, name: '基础业务', iconClass:'icon-yewu' },
		component: Layout,
		redirect: { path: '/basis/mail' },
		children: (pre => [{
				meta: {...meta, name:'派件管理' },
				path: '/basis/delivery',
				name: `${pre}-delivery`,
				component: () => import('../views/basis/delivery.vue') 
			},{
				meta: {...meta, name:'寄件管理' },
				path: '/basis/mail',
				name: `${pre}-mail`,
				component: () => import('../views/basis/mail.vue') 
			},{
				meta: {...meta, name:'短信管理' },
				path: '/basis/sms',
				name: `${pre}-sms`,
				component: () => import('../views/basis/sms.vue')
			},{
				meta: {...meta, name:'货架管理' },
				path: '/basis/shelves',
				name: `${pre}-shelves`,
				component: () => import('../views/basis/shelves.vue')
			}
		])('basis')
	},
	{
		path: '/site',
		name: 'site',
		meta: { ...menumeta, name: '网点管理', iconClass:'icon-dianpu' },
		component: Layout,
		redirect: { path: '/site/add' },
		children: (pre => [{
				meta: {...meta, name:'网点列表' },
				path: '/site/list',
				name: `${pre}-list`,
				component: () => import('../views/site/list.vue') 
			},{
				meta: {...meta, name:'编辑网点' },
				path: '/site/edit',
				name: `${pre}-edit`,
				component: () => import('../views/site/add.vue') 
			},{
				meta: {...meta, name:'网点分布地图' },
				path: '/site/map',
				name: `${pre}-map`,
				component: () => import('../views/site/map.vue') 
			},{
				meta: {...meta, name:'添加网点' },
				path: '/site/add',
				name: `${pre}-add`,
				component: () => import('../views/site/add.vue') 
			}
		])('site')
	},
	{
		path: '/user',
		name: 'user',
		meta: { ...menumeta, name: '用户管理', iconClass:'icon-yonghuguanli' },
		component: Layout,
		redirect: { path: '/user/add' },
		children: (pre => [{
				meta: {...meta, name:'添加用户' },
				path: '/user/add',
				name: `${pre}-add`,
				component: () => import('../views/user/add.vue') 
			},{
				meta: {...meta, name:'用户列表' },
				path: '/user/list',
				name: `${pre}-list`,
				component: () => import('../views/user/list.vue') 
			},{
				meta: {...meta, name:'快递员列表' },
				path: '/user/partner',
				name: `${pre}-partner`,
				component: () => import('../views/user/partner.vue') 
			}
		])('user')
	},
	{
		path: '/customer',
		name: 'customer',
		meta: { ...menumeta, name: '客户管理', iconClass:'icon-hezuofangkehuguanli' },
		component: Layout,
		redirect: { path: '/customer/list' },
		children: (pre => [{
				meta: {...meta, name:'客户列表' },
				path: '/customer/list',
				name: `${pre}-list`,
				component: () => import('../views/customer/list.vue') 
			}
		])('customer')
	},
	{
		path: '/settings',
		name: 'settings',
		meta: { ...menumeta, name: '设置', iconClass:'icon-guanggaoguanli' },
		component: Layout,
		redirect: { path: '/settings/admin-user' },
		children: (pre => [{
				meta: {...meta, name:'用户管理' },
				path: '/settings/admin-user',
				name: `${pre}-user`,
				component: () => import('../views/settings/adminUser.vue') 
			},{
				meta: {...meta, name:'菜单管理' },
				path: '/settings/menu',
				name: `${pre}-menu`,
				component: () => import('../views/settings/menu.vue') 
			},
			{
				meta: {...meta, name:'角色管理' },
				path: '/settings/role',
				name: `${pre}-role`,
				component: () => import('../views/settings/role.vue') 
			},
			{
				meta: {...meta, name:'审计日志' },
				path: '/settings/logs',
				name: `${pre}-logs`,
				component: () => import('../views/settings/logs.vue') 
			}
		])('settings')
	}
]